import { Address, ResultsParser } from '@multiversx/sdk-core/out';
import { useState, useEffect } from 'react';
import { handleUnexpectedException } from 'src/helpers/functions';
import { networkProvider } from 'src/utils/networkProvider';
import { smartContract } from 'src/utils/smartContract';

function useStakingPoolAddress(stakingType) {
    const [poolAddress, setPoolAddress] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPoolAddress = async () => {
            try {
                const resultParser = new ResultsParser();
                const interaction = smartContract.methods.smartContractAddress([stakingType]);
                const query = interaction.check().buildQuery();
                const queryResponse = await networkProvider.queryContract(query);

                const { firstValue } = resultParser.parseQueryResponse(queryResponse, interaction.getEndpoint());
                const addressHex = firstValue?.valueOf()?.valueHex;

                if (addressHex) {
                    setPoolAddress(Address.fromHex(addressHex).bech32());
                }
            } catch (err) {
                handleUnexpectedException(err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        if (stakingType) {
            fetchPoolAddress();
        }
    }, [stakingType]);

    return { poolAddress, loading, error };
}

export default useStakingPoolAddress;
